import { render } from "./DeveloperListView.vue?vue&type=template&id=5165289c&scoped=true"
import script from "./DeveloperListView.vue?vue&type=script&lang=js"
export * from "./DeveloperListView.vue?vue&type=script&lang=js"

import "./DeveloperListView.vue?vue&type=style&index=0&id=5165289c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5165289c"]])

export default __exports__